import React from 'react';
import _ from 'lodash';

import ga from '../../util/googleAnalytics';

import { propExistsAndNonEmpty } from '../../util/utils';
import DefaultAnswerIndexContainer from './answerOptions/defaultAnswerIndex/defaultAnswerIndexContainer';
import RankingMatrixIndexContainer from './answerOptions/rankingMatrixIndex/rankingMatrixIndexContainer';
import Nav from './nav/nav';
import './prompt.scss';

class Prompt extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            saveResultsConsent: false,
            isNonUs: false
        };

        this.handleConsent = this.handleConsent.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        if (propExistsAndNonEmpty(this.props.assessment)) {
            const { match, assessment, prompts } = this.props;
            const { promptId } = match.params;

            this.props.fetchPrompt(promptId);

            this.props.initializePromptQueue(assessment, prompts);

            this.props.updateProgress(promptId);

            this.props.initializeFilterQueue();
        }

        if (propExistsAndNonEmpty(this.props.countryInfo)) {
            this.setState({
                isNonUs:
                    this.props.countryInfo !== 'US' &&
                    this.props.countryInfo !== 'not_set'
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            assessment,
            location,
            match,
            promptQueue,
            prompts,
            prompt,
            countryInfo
        } = this.props;
        const { promptId } = match.params;

        if (assessment !== prevProps.assessment) {
            this.props.initializeFilterQueue();
        }

        if (assessment !== prevProps.assessment || location !== prevProps.location) {
            this.props.fetchPrompt(promptId);

            if (promptQueue.length < 1) {
                this.props.initializePromptQueue(assessment, prompts);
            }

            this.props.updateProgress(promptId);
        }

        if (prompt !== prevProps.prompt) {
            window.scrollTo(0, 0);
            ga.sendPageview(this.props, prompt.question);
        }

        if (countryInfo !== prevProps.countryInfo) {
            this.setState({
                isNonUs: this.props.countryInfo.countryCode !== 'US'
            });
        }
    }

    componentWillUnmount() {
        this.props.aggregateFilters();
        this.props.clearAllFilters();
    }

    handleConsent() {
        this.setState({ saveResultsConsent: !this.state.saveResultsConsent });
    }

    determineAnswerComponent() {
        const { prompt } = this.props;

        let component;

        switch (prompt.type) {
            case 'rankingMatrix':
                component = <RankingMatrixIndexContainer />;
                break;
            default:
                return <DefaultAnswerIndexContainer />;
        }

        return component;
    }

    render() {
        const { prompt, assessment, promptQueue } = this.props;
        const { saveResultsConsent, isNonUs } = this.state;
        const {id, header, description, question, blurb, modal} = prompt;

        let modalLink;
        let isLastPrompt = false;
        if (propExistsAndNonEmpty(prompt)) {
            if (modal) {
                modalLink = (
                    <em className="modal-link" onClick={() => this.props.openModal('dietDecide')}>
                        {' '}
                        How should I decide?
                    </em>
                );
            }

            isLastPrompt = promptQueue[promptQueue.length - 1] === id;
        }

        const saveResults = assessment?.resultsConfig?.saveResults;

        return (
            <div className="prompt">
                {header && (<h2>{header}</h2>)}
                {description && (<p>{description}</p>)}
                <h1 className={`question header ${assessment.site}`}>{question}</h1>
                <p className={`blurb ${assessment.site}`}>
                    {blurb} {modalLink}
                    <a
                        href={assessment.privacyPolicyUrl}
                        target="_blank"
                        className="privacy-text"
                        rel="noreferrer"
                    >
                        <span className="privacy">Privacy Policy</span>
                    </a>
                </p>
                {this.determineAnswerComponent()}

                {isLastPrompt && isNonUs && saveResults && (
                    <div className="optional-consent">
                        <label className="checkbox-text">
                            I consent to Healthline using my data to personalize my experience
                            through content and advertising
                            <input
                                type="checkbox"
                                className="checkbox"
                                id="optional-consent-checkbox"
                                name="optional-consent-checkbox"
                                value="optional-consent-checkbox"
                                onClick={this.handleConsent}
                            />
                            <span className="checkmark" />
                        </label>
                    </div>
                )}
                <Nav saveResultsConsent={saveResultsConsent || !isNonUs} site={assessment.site}/>
            </div>
        );
    }
}

export default Prompt;
